import { TimeQuestionConfig, TimeResponseState } from '@gripp/shared-logic';
import moment from 'moment';
import { useEffect } from 'react';
import { DatePickerSelector, useFormContext } from '../../../../../forms';
import {
  RoutineQuestionExecutionForm,
  RoutineQuestionExecutionFormProps,
} from '../../types';

export const DateOnly: RoutineQuestionExecutionForm<
  TimeQuestionConfig,
  TimeResponseState
> = (
  props: RoutineQuestionExecutionFormProps<
    TimeQuestionConfig,
    TimeResponseState
  >
) => {
  const fieldPrefix = `responses.${props.responseIndex}.timeTypeValue`;
  const { control, setValue } = useFormContext();

  useEffect(() => {
    const value =
      props.currentState?.state?.responses?.[props.responseIndex]
        ?.timeTypeValue;

    if (value) {
      const isString = typeof value === 'string';

      const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
      const matchesFormat = isString && dateRegex.test(value);

      const parsedDate = moment(value, 'MM/DD/YYYY', true);
      const isValidDate = matchesFormat && parsedDate.isValid();

      if (isValidDate) {
        setValue(
          fieldPrefix,
          props.currentState?.state?.responses?.[props.responseIndex]
            ?.timeTypeValue,
          {
            shouldDirty: true,
            shouldValidate: true,
          }
        );
      }
    }
  }, [props.currentState]);

  return (
    <DatePickerSelector
      name={fieldPrefix}
      setValue={setValue}
      control={control}
      label={''}
      placeholder="MM/DD/YYYY"
      height={40}
      containerStyle={{
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        paddingVertical: 0,
      }}
      maxYears={11}
    />
  );
};
